import { DELEGATION_FILTERS_TYPES } from '@constants/actionTypes/delegationActionTypes';

export const INITIAL_STATE = {};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case DELEGATION_FILTERS_TYPES.INIT_ALL_FILTERS: {
            return  { ...state, ...action.filtersValues };
        }
        case DELEGATION_FILTERS_TYPES.SET_FILTER_VALUE: {
            const { name, value } = action.newFilterValue;
            return { ...state, [name]: value
            };
        }
        case DELEGATION_FILTERS_TYPES.RESET_FILTER_VALUES: {
            return  action.filtersInitialValues;
        }
        default:
            return state;
    }
};